<app-page-header title="Mis expedientes" subtitle="Abre un expediente y consulta su estado" [accent]="true"></app-page-header>

<div class="expedientes-page">

    <main class="expedientes-main">

        <a class="open-event-card" *ngIf="showDirectAreas" (click)="irNuevoExpediente()" role="button" tabindex="0">
            <span class="open-event-icon" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5v14M5 12h14" stroke="#00558c" stroke-width="2.2" stroke-linecap="round"/>
                </svg>
            </span>
            <span class="open-event-text">Abre un nuevo expediente</span>
            <span class="open-event-chev" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M9 6l6 6-6 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </a>

        <section class="filters-panel" [class.collapsed]="filtersCollapsed">
            <header class="filters-head" (click)="toggleFilters()">
                <span class="filters-title">Filtros</span>
                <span class="filters-toggle" aria-hidden="true">
                    <svg *ngIf="filtersCollapsed" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12h14" stroke="#ffffff" stroke-width="2.2" stroke-linecap="round"/>
                    </svg>
                    <svg *ngIf="!filtersCollapsed" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5v14M5 12h14" stroke="#ffffff" stroke-width="2.2" stroke-linecap="round"/>
                    </svg>
                </span>
            </header>

            <div class="filters-body" *ngIf="!filtersCollapsed">

                <div class="filters-row">
                    <label class="filter-field">
                        <select [(ngModel)]="selectedSeguro" class="filter-input">
                            <option *ngFor="let s of seguros" [value]="s.value">{{ s.label }}</option>
                        </select>
                    </label>

                    <label class="filter-field">
                        <select [(ngModel)]="selectedEstado" class="filter-input">
                            <option *ngFor="let e of estados" [value]="e.value">{{ e.label }}</option>
                        </select>
                    </label>

                    <!-- El numero de expediente se elige de la lista que devuelve el servicio, no
                         se teclea: asi lo que se manda son numeros existentes y filtra el backend
                         sobre todos los expedientes. Mismo componente que el filtro del historico,
                         con el estilo de este panel. -->
                    <div class="filter-field filter-multiselect">
                        <angular2-multiselect [data]="expedientesList"
                                              [settings]="expedientesSettings"
                                              [(ngModel)]="expedientesSeleccionados">
                        </angular2-multiselect>

                        <!-- La libreria no sabe resumir la seleccion: o pinta una chip por
                             expediente (y entonces el campo crece de alto y descoloca la fila) o
                             no pinta nada. Se le quitan las chips por ajuste (badgeShowLimit) y
                             el resumen se escribe aqui encima. No lleva eventos propios ni recibe
                             el raton, para que el clic siga llegando al boton de la libreria y
                             abra el desplegable. El title repite el texto porque en movil, con
                             el campo estrecho, puede quedar recortado. -->
                        <span class="ms-resumen" *ngIf="expedientesSeleccionados?.length > 0"
                              [title]="resumenExpedientes">{{ resumenExpedientes }}</span>

                        <button type="button" class="ms-limpiar"
                                *ngIf="expedientesSeleccionados?.length > 0"
                                (click)="limpiarExpedientes($event)"
                                aria-label="Quitar los expedientes seleccionados">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M6 6l12 12M18 6L6 18" stroke="#64748b" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="filters-row filters-row--dates">
                    <label class="filter-field filter-field--date">
                        <span class="filter-label">Fecha (desde)</span>
                        <span class="filter-input-wrap">
                            <input type="date" class="filter-input filter-input--date" [(ngModel)]="fechaDesde" />
                        </span>
                    </label>

                    <label class="filter-field filter-field--date">
                        <span class="filter-label">Fecha (hasta)</span>
                        <span class="filter-input-wrap">
                            <input type="date" class="filter-input filter-input--date" [(ngModel)]="fechaHasta" />
                        </span>
                    </label>

                    <button type="button" class="btn-apply" (click)="aplicarFiltros()">Aplicar filtros</button>
                </div>

                <p class="filter-error" *ngIf="fechaError">{{ fechaError }}</p>

            </div>
        </section>

        <!-- Filtro de poliza que llega por la URL (?policy=) como quitaron el filtro lo añado aqui. -->
        <div class="active-filters" *ngIf="polizaFiltro">
            <span class="filter-chip">
                Póliza {{ polizaFiltro }}
                <button type="button" class="filter-chip-remove" (click)="quitarFiltroPoliza()"
                        aria-label="Quitar el filtro de póliza">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M6 6l12 12M18 6L6 18" stroke="#00558c" stroke-width="2.4" stroke-linecap="round"/>
                    </svg>
                </button>
            </span>
        </div>

        <section class="cards-grid" *ngIf="visibleCards.length > 0">
            <article class="card" *ngFor="let card of visibleCards">
                <header class="card-head">
                    <span class="card-icon" aria-hidden="true">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z"
                                  stroke="#00558c" stroke-width="1.6" stroke-linejoin="round"/>
                            <path d="M14 3v5h5" stroke="#00558c" stroke-width="1.6" stroke-linejoin="round"/>
                            <path d="M9 13h6M9 17h6" stroke="#00558c" stroke-width="1.6" stroke-linecap="round"/>
                        </svg>
                    </span>
                    <span class="card-state" [ngClass]="'state-' + card.estadoSlug">{{ card.estadoLabel }}</span>
                </header>

                <h3 class="card-title">{{ card.motivo }}</h3>

                <div class="card-section">
                    <span class="card-label">Nº de póliza</span>
                    <span class="card-value">{{ card.polizaNumero }}</span>
                </div>

                <div class="card-meta">
                    <p>
                        <span class="card-meta-label">Nº de expediente</span>
                        <span class="card-meta-value">{{ card.expedienteNumero }}</span>
                    </p>
                    <p *ngIf="card.fechaOcurrencia">
                        <span class="card-meta-label">Fecha de ocurrencia</span>
                        <span class="card-meta-value">{{ card.fechaOcurrencia }}</span>
                    </p>
                </div>

                <!-- Solo el asegurado del expediente puede entrar al detalle o escribir al
                     tramitador; al tomador que no es el asegurado se le muestra la tarjeta
                     informativa pero sin acciones. -->
                <footer class="card-actions" *ngIf="puedeOperar(card)">
                    <button type="button" class="btn-card btn-card--primary" (click)="irDetalle(card)">
                        Ver detalle
                    </button>
                    <button type="button" class="btn-card btn-card--accent" (click)="irMensajeria(card)">
                        Contacta tramitador/a
                    </button>
                </footer>
            </article>
        </section>

        <div class="empty-state" *ngIf="!loading && visibleCards.length === 0">
            <p>No hay expedientes que coincidan con los filtros aplicados.</p>
        </div>

        <div class="loading-state" *ngIf="loading && cards.length === 0">
            <p>Cargando expedientes<span>.</span><span>.</span><span>.</span></p>
        </div>

        <!-- Mismo paginado que el listado de recibos (profile-receipts). -->
        <!-- Se mira lo que hay en pantalla, no lo que trajo el servicio: sin resultados no debe
             quedar paginado colgando debajo del mensaje de "no hay expedientes". -->
        <nav class="ex-pagination" aria-label="Paginación"
             *ngIf="visibleCards.length > 0 && response?.totalPages > 1">
            <a class="ex-pag-link" [class.ex-pag-link--disabled]="response.first || loading"
               (click)="prev()">Anterior</a>
            <ul class="ex-pag-numbers">
                <li *ngFor="let p of getPages()"
                    [class.active]="p !== null && p === currentPage"
                    [class.ex-pag-ellipsis]="p === null"
                    (click)="p !== null && goToPage(p)">
                    {{ p !== null ? p : '...' }}
                </li>
            </ul>
            <a class="ex-pag-link" [class.ex-pag-link--disabled]="response.last || loading"
               (click)="next()">Siguiente</a>
        </nav>

    </main>

</div>

<app-footer></app-footer>
